module.exports = __webpack_public_path__ + "media/sora_cinematic_quality.f8be7486.mp4";